import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TeamUnreadState {
  // Map of conversationId -> true (only stores unread, remove when read)
  unreadConversations: Record<string, boolean>;
}

const initialState: TeamUnreadState = {
  unreadConversations: {},
};

const teamUnreadSlice = createSlice({
  name: 'teamUnread',
  initialState,
  reducers: {
    markTeamConversationUnread: (state, action: PayloadAction<string>) => {
      state.unreadConversations[action.payload] = true;
    },
    markTeamConversationRead: (state, action: PayloadAction<string>) => {
      delete state.unreadConversations[action.payload];
    },
    clearAllTeamUnread: (state) => {
      state.unreadConversations = {};
    },
  },
});

export const {
  markTeamConversationUnread,
  markTeamConversationRead,
  clearAllTeamUnread
} = teamUnreadSlice.actions;

type WithTeamUnread = { teamUnread: TeamUnreadState };
export const selectTeamUnreadConversations = (state: WithTeamUnread) =>
  state.teamUnread.unreadConversations;

export const selectIsTeamConversationUnread = (conversationId: string) => (state: WithTeamUnread) =>
  !!state.teamUnread.unreadConversations[conversationId];

export default teamUnreadSlice.reducer;
